import React from 'react';
import { Card, CardContent, CardHeader, IconButton, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { DirectionsCar, MoreVert } from '@material-ui/icons';
import { SimovsatVehicleStatus } from '~/types';

interface VehicleCardProps {
  vehicle: SimovsatVehicleStatus;
}

export default function VehicleCard({ vehicle }: VehicleCardProps) {
  const items = [
    { label: 'Contagem', value: vehicle.contagem },
    { label: 'Ligado', value: vehicle.ligado },
    { label: 'Off-line', value: vehicle.offline },
    { label: 'Nunca conectado', value: vehicle.nunca_conectado },
    { label: 'Expirado', value: vehicle.expirado },
  ];

  return (
    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <DirectionsCar />
            <Typography variant='h6' style={{ fontWeight: 'bold' }}>
              VEÍCULO
            </Typography>
          </div>
        }
        action={
          <IconButton size='small'>
            <MoreVert />
          </IconButton>
        }
        style={{ backgroundColor: '#f5f5f5', padding: '12px 16px' }}
      />
      <CardContent style={{ flex: 1, overflow: 'auto', padding: 0 }}>
        <List>
          {items.map((item, index) => (
            <ListItem key={index} divider>
              <ListItemText
                primary={item.label}
                secondary={item.value.toLocaleString('pt-BR')}
                primaryTypographyProps={{ style: { fontSize: '14px' } }}
                secondaryTypographyProps={{ style: { fontSize: '16px', fontWeight: 'bold', color: '#333' } }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
